<template>
  <div>
    <b-modal id="trip-status-modal">
      <div class="trip-status-modal">
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-if="Array.isArray(error)">
            <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
              {{ error_text }}
            </div>
          </div>
          <div v-else>
            <div v-html="error || '&nbsp;'"></div>
          </div>
        </b-alert>
        <div class="trip-status-header">
          <img src="@/assets/images/icons/alert-circle.svg" alt="popup status trip" srcset="" />
          <h3 class="success-modal__headerText">
            {{ $t('confirmation') }}
          </h3>
        </div>
        <h4>
          {{ $t('trip-status-update-text', { id: _id }) }}
          <span class="bold">{{ selectedStatus?.text }}</span>
          {{ isLangRtl ? '؟' : '?' }}
        </h4>
        <section v-if="selectedStatus?.value === 'Trip-Completed'">
          <validation-observer ref="observer">
            <div class="row">
              <div class="col-12">
                <base-input
                  type="number"
                  label="allowance-amount-max"
                  name="allowance-amount-max"
                  placeholder="allowance-amount-max"
                  id="service-allowance-amount-manage-trip"
                  field="serviceAllowance"
                  :value="formattedAmount(serviceAllowance)"
                  :disabled="true"
                />
              </div>
              <div class="col-12">
                <base-input
                  type="number"
                  label="allowance-amount"
                  name="allowance-amount"
                  placeholder="allowance-amount"
                  :rules="{
                    required: true,
                    min_value: 0,
                    maxValue: serviceAllowance,
                    decimalDigits: 2,
                  }"
                  :is_required="true"
                  id="allowance-amount-manage-trip"
                  field="allowanceAmount"
                  :value="allowanceAmount"
                  @change-value="handlerChangeAmount"
                />
              </div>
            </div>
          </validation-observer>
        </section>
        <section>
          <div class="d-flex justify-content-end buttons_container__content">
            <base-button
              cus_style="max-width:fit-content; !important;width:fit-content"
              :class="`primary me-3`"
              variant="secondary"
              id="Client-no-btn"
              @click="hideModal"
            >
              {{ $t('cancel') }}
            </base-button>

            <base-button
              cus_style="max-width:fit-content!important;width:fit-content"
              class="primary"
              variant="primary"
              id="Client-ok-btn"
              @click="submit"
              :loading="loading"
            >
              {{ $t('change-status') }}</base-button
            >
          </div>
        </section>
      </div>
    </b-modal>
    <div class="multiple-options-selection">
      <div
        class="handler d-flex align-items-center justify-content-end form-control"
        @click.stop="toggleFilterMenu"
      >
        <div class="place-holder">
          <div
            @click="
              isMainDriverAssigned &&
                isTripStatusSequence &&
                !isAllTripStatus &&
                status_options.length &&
                showModal(status_options[0])
            "
            :style="`float:${isLangRtl ? 'left' : 'right'};`"
            :class="[
              'status',
              {
                on_hold_status: status === 'Booking-Pending',
              },
              {
                completed_status:
                  status === 'Booking-Confirmed' ||
                  status === 'Trip-Completed' ||
                  status === 'Trip-Completed-Note',
              },
              {
                canceled_status:
                  status === 'Booking-Cancelled' || status === 'Booking-Cancelled-Note',
              },
              {
                rescheduled_status:
                  status === 'Booking-Re-Assigned' || status === 'Trip-Arrived-At-Pickup-Location',
              },
              {
                started_status: status === 'Trip-Started' || status === 'Trip-Passenger-Picked-Up',
              },
              {
                un_assigned_status: status === 'Booking-Un-Assigned',
              },
              {
                arrived_to_dropped_off_status: status === 'Trip-Arrived-To-Dropped-Off',
              },
              // {
              //   dropped_off_status: status === 'Trip-Passenger-Dropped-Off',
              // },
            ]"
          >
            {{ $t(status) }}
            <img
              :src="require(`@/assets/images/icons/chevron-down.svg`)"
              alt="chevron-down"
              :style="{
                transform: open_filter_menu && isAllTripStatus ? 'rotate(180deg)' : '',
              }"
              v-if="isMainDriverAssigned && status_options.length"
            />
          </div>
        </div>
      </div>
      <div
        v-if="isMainDriverAssigned && open_filter_menu && isAllTripStatus && status_options.length"
        v-click-outside="toggleFilterMenu"
        class="options"
        :style="isLangRtl ? 'left: 0px; width: 260px' : 'right: 0px; width: 260px'"
      >
        <div class="search-container">
          <base-input
            name="search status"
            placeholder="search-for-status"
            type="text"
            field="searchStatus"
            @change-value="setValue"
            :value="searchTerm"
            :small="true"
            class="customSearchTripStatus"
          />
          <img
            src="@/assets/images/icons/search-color-icon.svg"
            alt="search"
            class="search-icon"
            :style="isLangRtl ? 'left:10px' : 'right:10px'"
          />
        </div>
        <div
          v-for="(option, index) in filteredStatusOptions"
          :key="index"
          :class="
            option?.selected
              ? 'option d-flex align-items-center cursor-pointer p-2 selected'
              : 'option d-flex align-items-center cursor-pointer p-2'
          "
          @click="showModal(option)"
        >
          <div>
            {{ option?.text }}
          </div>
          <img
            src="@/assets/images/icons/check-black-icon.svg"
            alt="check"
            v-if="option?.selected"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TripService from '@/services/trip.service'

export default {
  props: ['status', '_id', 'getData', 'isMainDriverAssigned', 'serviceAllowance'],
  data() {
    return {
      open_filter_menu: false,
      status_options: [],
      searchTerm: '',
      selectedStatus: {},
      loading: false,
      error: null,
      inital_status_options: [
        { text: this.$t('Booking-Confirmed'), value: 'Booking-Confirmed' },
        { text: this.$t('Booking-Re-Assigned'), value: 'Booking-Re-Assigned' },
        { text: this.$t('Booking-Un-Assigned'), value: 'Booking-Un-Assigned' },
        { text: this.$t('Booking-Pending'), value: 'Booking-Pending' },
        { text: this.$t('Booking-Cancelled'), value: 'Booking-Cancelled' },
        {
          text: this.$t('Booking-Cancelled-Note'),
          value: 'Booking-Cancelled-Note',
        },
        { text: this.$t('Trip-Started'), value: 'Trip-Started' },
        {
          text: this.$t('Trip-Arrived-At-Pickup-Location'),
          value: 'Trip-Arrived-At-Pickup-Location',
        },
        {
          text: this.$t('Trip-Arrived-To-Dropped-Off'),
          value: 'Trip-Arrived-To-Dropped-Off',
        },
        { text: this.$t('Trip-Completed'), value: 'Trip-Completed' },
        { text: this.$t('Trip-Completed-Note'), value: 'Trip-Completed-Note' },
      ],
      allowanceAmount: this.serviceAllowance,
    }
  },
  methods: {
    toggleFilterMenu() {
      this.open_filter_menu = !this.open_filter_menu
    },
    setValue(val) {
      this.searchTerm = val
    },
    showModal(option) {
      this.selectedStatus = option
      this.toggleFilterMenu()
      this.$bvModal.show('trip-status-modal')
    },
    hideModal() {
      this.error = null
      this.$bvModal.hide('trip-status-modal')
    },
    initialSelectedOption() {
      this.selectedStatus = this.inital_status_options.find((each) => each.value === this.status) // #TODO : dobule check
      this.listStatusByPermission()
    },
    listStatusByPermission() {
      if (this.isAllTripStatus) {
        this.allPermissions()
      } else if (this.isTripStatusSequence) {
        this.sequencesPermissions()
      }
    },
    allPermissions(statusHandler) {
      let status = null
      this.status_option = []
      if (statusHandler) {
        status = statusHandler
      } else {
        status = this.status
      }

      switch (status) {
        case 'Booking-Confirmed':
        case 'Booking-Re-Assigned':
        // case "Booking-Un-Assigned":
        case 'Booking-Pending':
          this.status_options = [
            { text: this.$t('Trip-Started'), value: 'Trip-Started' },
            {
              text: this.$t('Trip-Arrived-At-Pickup-Location'),
              value: 'Trip-Arrived-At-Pickup-Location',
            },
            {
              text: this.$t('Trip-Arrived-To-Dropped-Off'),
              value: 'Trip-Arrived-To-Dropped-Off',
            },
            { text: this.$t('Trip-Completed'), value: 'Trip-Completed' },
          ]
          break
        case 'Trip-Started':
          this.status_options = [
            {
              text: this.$t('Trip-Arrived-At-Pickup-Location'),
              value: 'Trip-Arrived-At-Pickup-Location',
            },
            {
              text: this.$t('Trip-Arrived-To-Dropped-Off'),
              value: 'Trip-Arrived-To-Dropped-Off',
            },
            { text: this.$t('Trip-Completed'), value: 'Trip-Completed' },
          ]
          break
        case 'Trip-Arrived-At-Pickup-Location':
          this.status_options = [
            {
              text: this.$t('Trip-Arrived-To-Dropped-Off'),
              value: 'Trip-Arrived-To-Dropped-Off',
            },
            { text: this.$t('Trip-Completed'), value: 'Trip-Completed' },
          ]
          break
        // case "Trip-Passenger-Picked-Up":
        //   this.status_options = [
        //     {
        //       text: this.$t("Trip-Arrived-To-Dropped-Off"),
        //       value: "Trip-Arrived-To-Dropped-Off",
        //     },
        //     { text: this.$t("Trip-Completed"), value: "Trip-Completed" },
        //   ];
        //   break;
        case 'Trip-Arrived-To-Dropped-Off':
          this.status_options = [{ text: this.$t('Trip-Completed'), value: 'Trip-Completed' }]
          break
        // case "Trip-Passenger-Dropped-Off":
        //   this.status_options = [
        //     { text: this.$t("Trip-Completed"), value: "Trip-Completed" },
        //   ];
        //   break;
        default:
          this.status_options = []
      }
    },
    sequencesPermissions(statusHandler) {
      let status = null
      this.status_option = []
      if (statusHandler) {
        status = statusHandler
      } else {
        status = this.status
      }

      switch (status) {
        case 'Booking-Confirmed':
        case 'Booking-Re-Assigned':
        // case "Booking-Un-Assigned":
        case 'Booking-Pending':
          this.status_options = [{ text: this.$t('Trip-Started'), value: 'Trip-Started' }]
          break
        case 'Trip-Started':
          this.status_options = [
            {
              text: this.$t('Trip-Arrived-At-Pickup-Location'),
              value: 'Trip-Arrived-At-Pickup-Location',
            },
          ]
          break
        case 'Trip-Passenger-Picked-Up':
          this.status_options = [
            {
              text: this.$t('Trip-Arrived-To-Dropped-Off'),
              value: 'Trip-Arrived-To-Dropped-Off',
            },
          ]
          break
        case 'Trip-Passenger-Dropped-Off':
          this.status_options = [{ text: this.$t('Trip-Completed'), value: 'Trip-Completed' }]
          break
        default:
          this.status_options = []
      }
    },
    async submit() {
      if (this.selectedStatus.value === 'Trip-Completed') {
        const valid = await this.$refs.observer.validate()
        if (!valid) return
      }
      this.loading = true
      this.error = null
      const data = {
        status: this.selectedStatus.value,
        id: this._id,
        ...(this.selectedStatus.value === 'Trip-Completed' && {
          allowanceAmount: Number(this.allowanceAmount),
        }),
      }

      if (this.isAllTripStatus) {
        TripService.put(data, 'change-status-all')
          .then((res) => {
            this.$emit('getData', true)
            this.allPermissions(res.updatedTrip.status)
            this.$bvModal.hide('trip-status-modal')
          })
          .catch(({ message }) => {
            this.error = message
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        TripService.put(data, 'change-status-sequence')
          .then((res) => {
            this.$emit('getData', true)
            this.sequencesPermissions(res.updatedTrip.status)
            this.$bvModal.hide('trip-status-modal')
          })
          .catch(({ message }) => {
            this.error = message
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    handlerChangeAmount(val) {
      this.allowanceAmount = val
    },
  },
  computed: {
    filteredStatusOptions() {
      return this.status_options.filter((option) =>
        option.text.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    },
    isTripStatusSequence() {
      return !this.$store.getters['enums/is_not_permitted']('changeTripStatusSequence')
    },
    isAllTripStatus() {
      return !this.$store.getters['enums/is_not_permitted']('changeAllTripStatus')
    },
  },
  watch: {
    status: {
      immediate: true,
      handler() {
        this.listStatusByPermission()
      },
    },
  },
  mounted() {
    this.listStatusByPermission()
  },
}
</script>

<style lang="scss" scoped>
.handler {
  border: none;
}

.status {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.on_hold_status {
  background: var(--color-48);
  border: 1px solid var(--color-40);
  color: var(--color-29);
}

.completed_status {
  background: var(--color-19);
  border: 1px solid var(--color-16);
  color: var(--color-12);
}

.canceled_status {
  background: var(--color-20);
  border: 1px solid var(--color-39);
  color: var(--color-27);
}

.rescheduled_status {
  background: var(--color-18);
  border: 1px solid var(--color-41);
  color: var(--color-30);
}

.started_status {
  background: var(--color-52);
  border: 1px solid var(--color-41);
  color: var(--color-01);
}

.un_assigned_status {
  background: var(--color-47);
  border: 1px solid var(--color-39);
  color: var(--color-01);
}

.arrived_to_dropped_off_status {
  background: var(--color-130);
  border: 1px solid var(--color-41);
  color: var(--color-01);
}

.dropped_off_status {
  background: var(--color-05);
  border: 1px solid var(--color-41);
  color: var(--color-01);
}

.option {
  border-color: var(--color-64) !important;

  &:hover {
    background-color: var(--color-11);
  }
}

.selected {
  background-color: var(--color-11);
  font-weight: bold;
  justify-content: space-between;

  img {
    width: 24px;
  }
}

.search-container {
  position: relative;

  .search-icon {
    width: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}

// modal :
.trip-status-modal {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .trip-status-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--color-64);

    h3 {
      font-size: 20px;
      font-weight: bold;
      margin: 0;
    }
  }

  h4 {
    margin: 0;
    font-size: 16px;
  }
}

.bold {
  font-weight: bold;
}
</style>

<style lang="scss">
.customSearchTripStatus {
  margin-bottom: 0 !important;

  .form-control {
    box-shadow: none !important;
    border: none !important;
    border-radius: 0 !important;
    border-bottom: 1px solid var(--color-84) !important;
    color: var(--color-03) !important;
  }
}
</style>
